<template>
  <Text as="button" variant="body-large" color="secondary" class="see-all">See all</Text>
</template>

<script setup lang="ts">
import { Text } from '@tallo/design-system';
</script>

<style scoped lang="scss">
.see-all {
  appearance: none;
  border: none;
  background: none;
  white-space: nowrap;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
